// Clean canonical path: drop query/hash, trim trailing slash (except root `/`).
export const normalizeSeoPath = (pathname: string): string => {
  const clean = pathname.split(/[?#]/)[0] ?? '';
  return clean.length > 1 ? clean.replace(/\/+$/, '') : clean;
};
